<template lang="pug">
  .login-view-wrapper
    Login
</template>

<script type="text/javascript">
import Login from '@/components/login/Login'

export default {
  name: 'LoginView',
  components: {
    Login,
  },
  data() {
    return {}
  },
}
</script>



// WEBPACK FOOTER //
// src/components/LoginView.vue